exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.table[data-v-b87e4ea8] {\r\n    margin-top: 20px;\r\n    background-color: #fff;\n}\n.table thead th[data-v-b87e4ea8] {\r\n    background-color: #f8f9fa;\r\n    color: #333;\r\n    font-weight: bold;\n}\n.table tbody td[data-v-b87e4ea8],\r\n.table tbody th[data-v-b87e4ea8] {\r\n    padding: 12px 8px;\n}\n.ajax-loader[data-v-b87e4ea8] {\r\n    margin: 20px auto;\r\n    display: block;\n}\r\n", ""]);

// exports
